import React from 'react';
import s from '../../s';
import {observer} from 'mobx-react';
import LevelLockModal from '../modals/level-lock.modal';
import SmartBoxModal from '../modals/smart-box.modal';
import {computed, makeObservable, observable} from 'mobx';
import * as util from '../../../util';

declare const collapse: {
    init: () => void;
};

declare var __portal: IPortalSettings;

type Props = {};

@observer
export default class DescMainContent extends React.Component<Props> {
    @observable description: string;
    @observable init: boolean = false;

    constructor(props: Props) {
        super(props);
        makeObservable(this);
    }

    componentDidUpdate() {
        if (!this.init) {
            this.init = true;
            collapse.init();
        }
    }

    @computed get hide_dynamic(): boolean {
        if (!s.ready) {
            return false;
        }

        return [70214, 70215, 70244, 84054].includes(s.prod.ProductID) || ['391332'].includes(s.prod.ItemID);
    }

    @computed get show_doc_size(): boolean {
        if (!s.ready) {
            return false;
        }

        return s.pcs.docWidth >= 0 && s.pcs.docHeight >= 0 && !s.prod.Name.includes('collage') && s.prod.ProductTypeID != 25 && s.prod.IsFrame;
    }

    @computed get show_frame_size() {
        if (!s.ready) {
            return false;
        }

        return s.prod.JF_Width > 0;
    }

    @computed get show_custom_frame() {
        if (!s.ready) {
            return false;
        }

        return s.prod.IsFrame && s.prod.ProductTypeID !== 67;
    }

    @computed get show_smart_box() {
        if (!s.ready) {
            return false;
        }

        if (!s.ui.allow_smartbox) {
            return false;
        }

        return s.prod.Shipping_BoxID <= 3 && s.prod.IsFrame && !s.prod.ProductTypeDisplayName.toLowerCase().includes('Photo') && !this.hide_dynamic;
    }

    @computed get jf_width() {
        if (!s.ready || !this.show_frame_size) {
            return false;
        }

        return util.roundF(s.prod.JF_Width - s.prod.docWidth + s.pcs.docWidth + s.pcs.moulding_extWidth * 2, 1);
    }

    @computed get jf_height() {
        if (!s.ready || !this.show_frame_size) {
            return false;
        }

        return util.roundF(s.prod.JF_Height - s.prod.docHeight + s.pcs.docHeight + s.pcs.moulding_extWidth * 2, 1);
    }

    render() {
        return (
            <>
                {s.si && s.si.StoreID !== 205255 && !s.si.has_bullet_override && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.description || s.si.default_prod_info_static,
                        }}
                    />
                )}
                {!this.hide_dynamic && s.si.StoreID !== 205255 && !s.si.has_bullet_override && (
                    <ul>
                        {!s.prod.IsCAF && this.show_doc_size && <li>{`${s.si.ph_desc_size} ${s.pcs.docWidth}"w x ${s.pcs.docHeight}"h`}</li>}
                        {!s.prod.IsCAF && this.show_frame_size && <li>{`${s.si.ph_desc_jf_size} ${this.jf_width}"w x ${this.jf_height}"h`}</li>}

                        {!s.prod.IsCAF && s.prod.LevelLock && (s.PortalID === 0 || !__portal.DisableProdDescLinks) && !s.prod.HideLevelLock && (
                            <li>
                                {s.si.ph_desc_ll} <LevelLockModal />
                            </li>
                        )}

                        {!s.prod.IsCAF && s.prod.LevelLock && (s.PortalID !== 0 || __portal.DisableProdDescLinks) && !s.prod.HideLevelLock && <li>{s.si.ph_desc_ll} Level-Lock Frame Hanging System!</li>}

                        {!s.prod.IsCAF && this.show_smart_box && (s.PortalID === 0 || !__portal.DisableProdDescLinks) && (
                            <li>
                                {s.si.ph_desc_smart} <SmartBoxModal />
                            </li>
                        )}

                        {!s.prod.IsCAF && this.show_smart_box && (s.PortalID !== 0 || __portal.DisableProdDescLinks) && <li>{s.si.ph_desc_smart} SMARTbox package</li>}

                        {!s.prod.IsCAF && this.show_custom_frame && s.si.StoreTypeID === 5 && <li>This custom frame is handcrafted in the USA.</li>}
                        {!s.prod.IsCAF && this.show_custom_frame && s.si.StoreTypeID !== 5 && <li>{s.si.ph_desc_custom}</li>}
                        {!s.prod.IsCAF && s.prod.CustomizationMethod === 2 && s.PortalID === 0 && s.prod.ProductTypeID === 25 && (
                            <li>
                                Customize your Varsity Letter frame with <a href="/frame-designer/design-your-frame/4">Create-a-Frame</a>
                            </li>
                        )}

                        {s.prod.IsCAF && this.show_doc_size && <li>{`${s.prod.DocType} Size: ${s.pcs.docWidth}"w x ${s.pcs.docHeight}"h`}</li>}
                        {s.prod.IsCAF && this.show_frame_size && <li>{`Approx. Overall Frame Size: ${this.jf_width}"w x ${this.jf_height}"h`}</li>}

                        {s.prod.IsCAF && s.prod.LevelLock && !s.prod.HideLevelLock && s.PortalID === 0 && (
                            <li>
                                Includes our easy-to-use <LevelLockModal />
                            </li>
                        )}

                        {s.prod.IsCAF && this.show_smart_box && s.PortalID === 0 && (
                            <li>
                                This frame ships in a branded <SmartBoxModal />
                            </li>
                        )}

                        {s.prod.IsCAF && this.show_custom_frame && s.si.StoreTypeID === 5 && <li>This custom frame is handcrafted in the USA.</li>}
                        {s.prod.IsCAF && this.show_custom_frame && s.si.StoreTypeID !== 5 && <li>This custom frame is handcrafted in the USA and made-to-order.</li>}
                        {!s.pcs.is_caf && !util.isNullOrWhiteSpace(s.ui.item_id) && <li>Item #: {s.ui.item_id}</li>}
                        {!s.pcs.is_caf && !util.isNullOrWhiteSpace(s.ui.sku) && <li>SKU: {s.ui.sku}</li>}
                        {s.prod.IsCAF && s.prod.DYF_FrameStyleID === 10 && s.pcs.docWidth <= 7 && <li>Includes easel back</li>}
                        {s.prod.IsCAF && <li>{s.prod.DYF_FrameStyleName}</li>}
                        {s.prod.IsCAF && <li>{s.ui.title_moulding} Moulding</li>}
                        {s.prod.IsCAF && <li>{s.ui.title_mat1} Top Mat</li>}
                        {s.prod.IsCAF && s.pcs.mat2_id > 0 && <li>{s.ui.title_mat2} Inner Accent</li>}
                        {s.prod.IsCAF && s.pcs.insignia_id > 0 && <li>{s.ui.title_insignia} Insignia</li>}
                        {s.prod.IsCAF && s.pcs.lino_id > 0 && <li>{s.pcs.lino_base_name} Embossed Text</li>}
                        {s.prod.IsCAF && s.pcs.ep_id > 0 && <li>Engraved Plate</li>}
                        {s.prod.IsCAF && <li>{s.pcs.is_horizontal ? 'Horizontal' : 'Vertical'} Orientation</li>}
                        {s.prod.IsCAF && s.pcs.glass_id > 1 && (
                            <li>
                                {s.ui.name_glass} {s.prod.AllowGlassID1 === 2 || s.pcs.use_plexi ? 'Plexiglass' : 'Glass'}
                            </li>
                        )}
                    </ul>
                )}

                {!this.hide_dynamic && s.si.has_bullet_override && s.si.default_prod_info_dynamic != null && s.si.default_prod_info_dynamic.length > 0 && (
                    <ul>
                        {s.si.default_prod_info_dynamic.map((m, i) => (
                            <li key={i}>{m}</li>
                        ))}
                    </ul>
                )}
            </>
        );
    }
}
